/** Bajie's faultCause field comes back as a Chinese explanation often
 *  concatenated with a trailing "YYYY-MM-DD HH:mm:ss" timestamp and no
 *  delimiter, plus sometimes English / mixed text. This module pulls
 *  out the timestamp and translates the most common Chinese phrases. */

const ZH_PHRASES: Array<[RegExp, string]> = [
  [/无法正确识别充电宝ID[，,]?\s*请弹出充电宝检修/, "battery ID unreadable — eject for service"],
  [/电池.*?膨胀|膨胀/, "swelling"],
  [/无法充电/, "cannot charge"],
  [/认证失败|授权失败/, "authorization failed"],
  [/重复.*?ID/, "duplicate battery id"],
  [/电池.*?召回|召回/, "battery recall"],
  [/健康.*?不达标/, "health substandard"],
  [/超出使用限制/, "overuse limit"],
  [/Apple接口|苹果接口/, "Apple connector fault"],
  [/USB接口|USB-C接口/, "USB connector fault"],
  [/虚电/, "virtual power"],
  [/请弹出充电宝检修/, "eject for service"],
  [/请弹出/, "needs ejection"],
];

const TS_RE = /\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/;

export interface ParsedCause {
  reason: string | null;
  detectedAt: string | null;
  /** True if we confidently translated; false if we're returning the raw
   *  string with timestamp peeled off. */
  translated: boolean;
}

export function parseFaultCause(raw: string | null | undefined): ParsedCause {
  if (!raw) return { reason: null, detectedAt: null, translated: false };
  const tsMatch = raw.match(TS_RE);
  const detectedAt = tsMatch ? tsMatch[0].replace("T", " ") : null;
  const stripped = raw.replace(TS_RE, "").trim();
  if (!stripped) return { reason: null, detectedAt, translated: false };

  for (const [re, en] of ZH_PHRASES) {
    if (re.test(stripped)) return { reason: en, detectedAt, translated: true };
  }
  // No translation matched — return the cleaned string but flag as untranslated.
  return { reason: stripped, detectedAt, translated: false };
}

const GHOST_RE = /^0+$/;
export function isGhostBatteryId(id: string | null | undefined): boolean {
  return !!id && GHOST_RE.test(id);
}
